import React from 'react';
import { Icon } from './Icon.js';
export const IconDarkModeFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,17c-4.411,0-8-3.589-8-8S4.589,1,9,1s8,3.589,8,8-3.589,8-8,8Zm0-14.5c-3.584,0-6.5,2.916-6.5,6.5s2.916,6.5,6.5,6.5,6.5-2.916,6.5-6.5-2.916-6.5-6.5-6.5Z", fill: "currentColor" }),
        React.createElement("path", { d: "M9,14V4c-2.761,0-5,2.239-5,5s2.239,5,5,5Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconDarkModeFill18.js.map